import React from 'react';
import Modal from '../../components/Modal';

const TermsAndConditionsModal = ({onClose}) => {
    const body = <div className='overflow-auto max-h-[400px] pr-2'>
        <div className="space-y-5 text-sm text-surface-600 leading-relaxed">
            <p className="text-surface-500">
                Bileti almazdan öncə diqqətlə oxuyun və razılaşdığınızı təsdiq edin.
            </p>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">1. Ümumi müddəalar</h4>
                <ul className="list-disc ml-5 space-y-1.5 text-surface-500">
                <li>Bu qaydalar Tixy.az portalı tərəfindən təyin edilir.</li>
                <li>Bilet əldə etməklə siz bu qaydalara tam razı olduğunuzu təsdiq etmiş olursunuz.</li>
                </ul>
            </div>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">2. Biletin istifadə qaydası</h4>
                <ul className="list-disc ml-5 space-y-1.5 text-surface-500">
                <li>Hər bilet yalnız bir nəfər üçün keçərlidir.</li>
                <li>Biletlər şəxsi istifadə üçün nəzərdə tutulub və kommersiya məqsədilə təkrar satışı qadağandır.</li>
                <li>Tədbirə daxil olmaq üçün biletin fiziki və ya elektron versiyası təqdim edilməlidir.</li>
                </ul>
            </div>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">3. Biletin geri qaytarılması</h4>
                <ul className="list-disc ml-5 space-y-1.5 text-surface-500">
                <li>Tədbirin başlamasına <strong>7 gündən çox</strong> vaxt qalıbsa, bilet geri qaytarıla bilər. Bu halda biletin dəyərinin <strong>30%-i</strong> cərimə kimi saxlanılır, qalan 70% alıcıya qaytarılır.</li>
                <li>Tədbirin başlamasına <strong>7 gün və ya daha az</strong> vaxt qalıbsa, bilet geri qaytarılmır və dəyişdirilmir.</li>
                <li>Geri qaytarma üçün tədbir səhifəsində göstərilən dəstək nömrəsi ilə əlaqə saxlayın.</li>
                <li>Tədbirin təşkili ilə bağlı dəyişikliklər olduğu halda, təşkilatçı alternativ tədbirlər və ya qaytarma şərtləri barədə məlumat verəcək.</li>
                </ul>
            </div>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">4. Təhlükəsizlik qaydaları</h4>
                <ul className="list-disc ml-5 space-y-1.5 text-surface-500">
                <li>Tədbirdə iştirak edən hər kəs təşkilatçının təlimatlarına əməl etməlidir.</li>
                <li>Qanunsuz davranış aşkarlandıqda iştirakçı tədbirdən uzaqlaşdırıla bilər.</li>
                <li>10 yaşdan kiçik iştirakçılar yalnız valideyn ilə iştirak edə bilər.</li>
                </ul>
            </div>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">5. Foto və video çəkiliş</h4>
                <p className="text-surface-500">
                Təşkilatçı foto və video çəkiliş həyata keçirə bilər. İştirakçı bu materialların reklam məqsədilə istifadəsinə etiraz etmədiyini təsdiq edir.
                </p>
            </div>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">6. Fors-major hallar</h4>
                <p className="text-surface-500">
                Nəzarətdən kənar səbəblərdən tədbir ləğv olunduqda, təşkilatçı məsuliyyət daşımır. Mümkün həll yolları barədə məlumat veriləcək.
                </p>
            </div>

            <div>
                <h4 className="font-semibold text-surface-900 mb-2">7. Məlumatların qorunması</h4>
                <p className="text-surface-500">
                Şəxsi məlumatlar yalnız tədbirə aid məqsədlərlə istifadə olunur və üçüncü tərəflərə ötürülmür.
                </p>
            </div>

            <div className="bg-surface-50 rounded-2xl p-4 mt-4">
                <p className="font-medium text-surface-700 text-sm">
                Bileti alaraq yuxarıda qeyd olunan qaydalar və şərtlərlə tam razı olduğumu təsdiq edirəm.
                </p>
            </div>
        </div>
    </div>

    return <Modal
        title="Bilet satış qaydaları"
        body={body}
        buttons={
            <>
                <button type="button" onClick={() => onClose(true)} className="w-full sm:w-auto inline-flex justify-center rounded-2xl bg-accent-600 px-6 py-3 text-sm font-semibold text-white hover:bg-accent-700 transition">Qəbul edirəm</button>
                <button onClick={() => onClose(false)} type="button" className="w-full sm:w-auto mt-3 sm:mt-0 inline-flex justify-center rounded-2xl bg-white px-6 py-3 text-sm font-semibold text-surface-700 ring-1 ring-inset ring-surface-200 hover:bg-surface-50 transition">Bağla</button>
            </>
        }
    />
}

export default TermsAndConditionsModal;
